// extracted by mini-css-extract-plugin
export default {"mainContainer":"FeedbackForm_mainContainer__RI9y-","formDiv":"FeedbackForm_formDiv__oPE1P","buttons":"FeedbackForm_buttons__zfC2Y","submitBtn":"FeedbackForm_submitBtn__vn3hr"};